import script from "./ListItemsSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListItemsSelect.vue?vue&type=script&setup=true&lang=ts"

import "./ListItemsSelect.vue?vue&type=style&index=0&id=d09b1e36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d09b1e36"]])

export default __exports__